import { IEnvironment } from './env.interface';

export const env: IEnvironment = {
    production: false,

    apiUrl: 'https://api.staging.flumewater.com',
    staticUrl: 'https://staging.flumewater.com',

    auth: {
        clientId: 'customer-portal',
        accessTokenName: 'at_portal_staging',
        accessTokenLifetimeHours: 4,
        refreshTokenName: 'rt_portal_staging',
        refreshTokenExpires: 365, // 1 year
        stateTokenName: 'oauth_state',
        https: true,
        interval: 5000,
    },

    intercom: 'peo9fh7g',
    amplitude: 'c71d1ab19e74a78b4f3ce1480eee5fe1',
};
